import React from 'react';
import { convertHttps } from '../../../utils/helper';

const Information = props => {
  const { info, passingUtmData, showTryOn = true } = props;
  return (
    <div
      className="display-flex align-items-center justify-space-between pd-15 text-dark_grey_blue"
      onClick={() => passingUtmData('BUY_ON_CALL')}
    >
      {showTryOn && (
        <div className="text-left roboto-slab fsp24">
          {info?.heading && <div className="fsp14">{info?.heading}</div>}
          {info?.sub_text_1 && <div className="fw300">{info?.sub_text_1}</div>}
          {info?.sub_text_2 && <div className="fw700">{info?.sub_text_2}</div>}
          {info?.sub_text_3 && (
            <div
              dangerouslySetInnerHTML={{ __html: info?.sub_text_3 }}
              className="fsp10 fw100"
            ></div>
          )}
        </div>
      )}
      {info?.logo && showTryOn && (
        <img alt={info?.sub_text_2 ? info?.sub_text_2 : info?.heading} src={convertHttps(info?.logo)} />
      )}
    </div>
  );
};

export default Information;
